import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ApresentacaoService {
  getLinhaTempo() {
    return [
      {
        id: 1,
        edição: 'Primeira edição',
        evolucao: '98 cursos, 10 Eixos Tecnológicos, carga horária e infraestrutura mínimas para os cursos',
        data: '2006',
        ano: 2006,
        nome: 'cncst_2006.pdf',
      },
      {
        id: 2,
        edição: 'Segunda edição',
        evolucao: '112 cursos, criação de 3 novos Eixos Tecnológicos',
        data: '2010',
        ano: 2010,
        nome: 'cncst_2010.pdf',
      },
      {
        id: 3,
        edição: 'Terceira edição',
        evolucao: '134 cursos, inclusão do campo de atuação, ocupações CBO e itinerário de pós-graduação',
        data: '2016',
        ano: 2016,
        nome: 'cncst_2016.pdf',
      },
    ];
  }
}
